module.exports = __webpack_public_path__ + "static/media/threshold-exceeded-yellow.4e6b8d47.svg";